import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'angular2-toaster';

import { AlertService } from '../../services/index';

 
@Component({
    moduleId: module.id,
    selector: 'alert',
    template: ``
})
 
export class AlertComponent {
    //message: any;
 

}


// WEBPACK FOOTER //
// ./src/app/components/share/alert.component.ts